import { render, staticRenderFns } from "./MathQuillEditor.vue?vue&type=template&id=3406b824&scoped=true"
import script from "./MathQuillEditor.vue?vue&type=script&lang=js"
export * from "./MathQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./MathQuillEditor.vue?vue&type=style&index=0&id=3406b824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406b824",
  null
  
)

export default component.exports